<template>
  <v-card outlined class="pa-2">
    <div>
      <!--GRUPOS-->
      <v-row no-gutters>
        <v-col md="4">
          <v-card class="mr-1" style="border-bottom: none" outlined tile>
            <v-data-table
              :loading="loading"
              loading-text="Carregando, aguarde..."
              :headers="headers"
              :items="grupos.data"
              :sort-desc="sortDesc"
              :items-per-page="1000"
              hide-default-footer
              hide-action
              sort-by="id"
              item-key="id"
            >
              <template v-slot:body="{ items }">
                <tr v-for="item in items" :key="item.id" :class="item === grupoSelecionado ? 'fs-tr-selected' : 'fs-row-click'" @click="grupoSelecionado = item">
                  <td>{{ item.id }}</td>
                  <td>{{ item.descricao }}</td>
                  <td>
                    <v-chip v-if="item.ativo === 'S'" class="fs-chip" small color="success" text-color="white">Sim</v-chip>
                    <v-chip v-else class="fs-chip" small color="error" text-color="white">Não</v-chip>
                  </td>
                  <td width="85px">
                    <v-btn small class="ml-4" @click="dialogGrupo = true" icon>
                      <v-icon>mdi-pen</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          <v-btn class="mt-2 primary" @click="atualizarDados()">
            <v-icon class="mr-1 ml-n1">
              mdi-refresh
            </v-icon>
            Atualizar Dados
          </v-btn>
        </v-col>

        <!--TELAS-->
        <v-col v-if="grupoSelecionado" md="8">
          <v-card class="ml-2" outlined tile>
            <perfect-scrollbar style="max-height: 750px">
              <v-data-table
                loading-text="Carregando, aguarde..."
                :headers="headersTelas"
                :items="grupoSelecionado.acessoGrupoTelas"
                :sort-desc="sortDesc"
                hide-default-footer
                :items-per-page="1000"
                hide-action
                sort-by="id"
                item-key="id"
              >
                <template v-slot:body="{ items }">
                  <tr class="fs-row" v-for="item in items" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.tela.modulo.aplicacao.toUpperCase() }}</td>
                    <td>{{ item.tela.modulo.descricao }}</td>
                    <td>{{ item.tela.descricao }}</td>
                    <td>
                      <v-chip v-if="item.visivel === 'S'" class="fs-chip" small color="success" text-color="white">Sim</v-chip>
                      <v-chip v-else class="fs-chip" small color="error" text-color="white">Não</v-chip>
                    </td>
                    <td>
                      <v-chip v-if="item.habilitado === 'S'" class="fs-chip" small color="success" text-color="white">Sim</v-chip>
                      <v-chip v-else class="fs-chip" small color="error" text-color="white">Não</v-chip>
                    </td>
                <!-- <td>{{ item.ativo === 'S' ? 'Sim' : 'Não' }}</td> -->
                    <td width="100px">
                      <v-btn class="ml-2" small @click="abrirDialogGrupoTela(item)" icon>
                        <v-icon>mdi-pen</v-icon>
                      </v-btn>
                      <v-btn small @click="abrirDialogFuncionalidades(item)" icon>
                        <v-icon>mdi-lock-open</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </perfect-scrollbar>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!--DIALOG EDITAR TELA-->
    <v-dialog v-if="grupoTelaSelecionado" v-model="dialogGrupoTela" width="700px">
      <v-card class="pa-3 pt-4">
        <h2 class="ml-1">Editar Tela</h2>
        <v-divider class="mt-3 mb-5 mx-1"></v-divider>
        <v-form autocomplete="off" ref="form">
          <div class="mt-n2 ml-2 mb-4">
            Grupo: <b>{{ grupoSelecionado.descricao }}</b>
          </div>
          <v-row no-gutters>
            <v-col md="6">
              <v-text-field
                class="mx-1 mb-n3"
                v-model="grupoTelaSelecionado.tela.modulo.descricao"
                label="Módulo"
                disabled
                outlined
                dense
              />
            </v-col>
            <v-col md="6">
              <v-text-field
                class="mx-1 mb-n3"
                v-model="grupoTelaSelecionado.tela.descricao"
                label="Tela"
                disabled
                outlined
                dense
              />
            </v-col>
            <v-col>
              <v-select
                class="mx-1"
                v-model="grupoTelaSelecionado.visivel"
                :items="[{ text: 'Sim', value: 'S' }, { text: 'Não', value: 'N' }]"
                spellcheck="false"
                item-text="text"
                item-value="value"
                label="Visível"
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                class="mx-1"
                v-model="grupoTelaSelecionado.habilitado"
                :items="[{ text: 'Sim', value: 'S' }, { text: 'Não', value: 'N' }]"
                spellcheck="false"
                item-text="text"
                item-value="value"
                label="Habilitado"
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="mr-n2 mb-n2">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="editarGrupoTela()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar Tela
          </v-btn>
          <v-btn color="warning" @click="dialogGrupoTela = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DIALOG EDITAR GRUPO-->
    <v-dialog v-if="grupoSelecionado" v-model="dialogGrupo" width="700px">
      <v-card class="pa-3 pt-4">
        <h2 class="ml-1">Editar Grupo</h2>
        <v-divider class="mt-3 mb-5 mx-1"></v-divider>
        <v-form autocomplete="off" ref="form">
          <div class="mt-n2 ml-2 mb-4">
            Grupo: <b>{{ grupoSelecionado.descricao }}</b>
          </div>
          <v-row no-gutters>
            <v-col md="6">
              <v-text-field
                class="mx-1 mb-n3"
                v-model="grupoSelecionado.descricao"
                label="Descrição"
                outlined
                dense
              />
            </v-col>
            <v-col md="6">
              <v-select
                class="mx-1"
                v-model="grupoSelecionado.ativo"
                :items="[{ text: 'Sim', value: 'S' }, { text: 'Não', value: 'N' }]"
                spellcheck="false"
                item-text="text"
                item-value="value"
                label="Ativo"
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="mr-n2 mb-n2">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="editarGrupo()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar Grupo
          </v-btn>
          <v-btn color="warning" @click="dialogGrupo = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DIALOG FUNCIONALIDADES-->
    <v-dialog v-if="grupoSelecionado && grupoTelaSelecionado" v-model="dialogFuncionalidades" width="700px">
      <v-card class="pa-3 pt-4">
        <h2 class="ml-1">Editar Funcionalidades</h2>
        <v-divider class="mt-3 mb-5 mx-1"></v-divider>
          <div class="mt-n2 ml-2 mb-4">
            Grupo: <b>{{ grupoSelecionado.descricao }}</b> / Tela: <b>{{ grupoTelaSelecionado.tela.descricao }}</b>
          </div>
          <v-card class="mx-1" outlined>
            <v-data-table
              loading-text="Carregando, aguarde..."
              :headers="headersFuncionalidades"
              :items="funcionalidadesTela"
              :sort-desc="sortDesc"
              hide-default-footer
              :items-per-page="1000"
              hide-action
              sort-by="id"
              item-key="id"
            >
              <template v-slot:body="{ items }">
                <tr class="fs-row" v-for="item in items" :key="item.id">
              <!--<td>{{ item.id }}</td>-->
                  <td style="text-transform: uppercase">{{ item.funcionalidade.descricao }}</td>
                  <td>
                    <v-checkbox
                      v-model="item.visivel"
                      :value="item.visivel"
                      color="#2A2F50"
                      false-value="N"
                      true-value="S"
                      class="ma-0 pa-0 ml-1"
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td width="120px">
                    <v-checkbox
                      v-model="item.habilitado"
                      :value="item.habilitado"
                      color="#2A2F50"
                      false-value="N"
                      true-value="S"
                      class="ma-0 pa-0 ml-4"
                      hide-details
                    ></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        <v-card-actions class="mt-4 mr-n2 mb-n2">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="editarFuncionalidades()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar Funcionalidades
          </v-btn>
          <v-btn color="warning" @click="dialogFuncionalidades = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// eslint-disable-next-line
import { add, list, edit } from '@/api/crud'
import * as api from '@/api/acesso'
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Ativo', value: 'ativo' },
        { text: 'Editar', align: 'center', sortable: false }
      ],
      headersTelas: [
        { text: 'ID', value: 'id' },
        { text: 'Aplicação', value: 'tela.modulo.aplicacao' },
        { text: 'Módulo', value: 'tela.modulo.descricao' },
        { text: 'Tela', value: 'tela.descricao' },
        { text: 'Visível', value: 'visivel' },
        { text: 'Habilitado', value: 'habilitado' },
        // { text: 'ATIVO', value: 'ativo' },
        { text: 'Ações', align: 'center', sortable: false }
      ],
      headersFuncionalidades: [
        // { text: 'ID', value: 'id' },
        { text: 'Funcionalidade', value: 'funcionalidade.descricao', sortable: false },
        { text: 'Visível', value: 'visivel', sortable: false },
        { text: 'Habilitado', value: 'habilitado', sortable: false }
        // { text: 'AÇÕES', align: 'center', sortable: false }
      ],
      grupos: [],
      funcionalidadesTela: [],
      dialogGrupo: false,
      dialogGrupoTela: false,
      dialogFuncionalidades: false,
      grupoSelecionado: null,
      grupoTelaSelecionado: null,
      loading: true,
      sortDesc: false
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    })
  },
  mounted () {
    this.carregarGrupos()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    async atualizarDados () {
      this.loading = true
      try {
        await api.acessoGruposRefresh()
        this.setSnackbar({ msg: 'Dados atualizados! Recarregue a página atual.', color: 'green' })
      } catch (error) {
        this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
      }
      this.loading = false
    },
    async carregarGrupos () {
      this.grupos = await list('/admin/acessogrupos')
      this.grupoSelecionado = this.grupos.data[0]
      // console.log(this.grupos)
      this.loading = false
    },
    abrirDialogGrupoTela (item) {
      this.dialogGrupoTela = true
      this.grupoTelaSelecionado = item
    },
    abrirDialogFuncionalidades (value) {
      this.grupoTelaSelecionado = value
      this.funcionalidadesTela = (this.grupoSelecionado.acessoGrupoFuncionalidades).filter(item => {
        return item.funcionalidade.acesso_tela_id === value.acesso_tela_id
      })
      this.dialogFuncionalidades = true
    },
    async editarGrupoTela () {
      if (await this.confirm.open('Editar Tela', 'Tem certeza que deseja prosseguir?', { color: 'error' })) {
        const obj = {
          visivel: this.grupoTelaSelecionado.visivel,
          habilitado: this.grupoTelaSelecionado.habilitado
        }
        try {
          await edit('/admin/acessogrupotela', 'editar', this.grupoTelaSelecionado.id, obj)
          this.dialogGrupoTela = false
          this.setSnackbar({ msg: 'Tela editada com sucesso!', color: 'green' })
        } catch (e) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${e}` })
        }
      }
    },
    async editarGrupo () {
      if (await this.confirm.open('Editar Grupo', 'Tem certeza que deseja prosseguir?', { color: 'error' })) {
        const obj = {
          descricao: this.grupoSelecionado.descricao,
          ativo: this.grupoSelecionado.ativo
        }
        try {
          await edit('/admin/acessogrupos', 'editar', this.grupoSelecionado.id, obj)
          this.dialogGrupo = false
          this.setSnackbar({ msg: 'Grupo editado com sucesso!', color: 'green' })
        } catch (e) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${e}` })
        }
      }
    },
    async editarFuncionalidades () {
      if (await this.confirm.open('Editar Funcionalidades', 'Tem certeza que deseja prosseguir?', { color: 'error' })) {
        const obj = this.funcionalidadesTela.map(item => {
          return { id: item.id, visivel: item.visivel, habilitado: item.habilitado }
        })
        try {
          await add('/admin/acessogrupofuncionalidades', 'incluir', { obj: obj })
          this.dialogFuncionalidades = false
          this.setSnackbar({ msg: 'Funcionalidades editadas com sucesso!', color: 'green' })
        } catch (e) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${e}` })
        }
      }
    }
  }
}
</script>

<style scoped>
  .fs-row-click {
    cursor: pointer;
  }
  .fs-row:hover, .fs-row-click:hover {
    background-color: #EEEEEE;
  }
  .fs-card-radius {
    border-bottom: none !important;
    border-radius: 5px;
  }
</style>
